import * as React from 'react';
import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import ChartInput from 'components/molecules/InputText/ChatInput';
import Checkbox from '@mui/material/Checkbox';
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import Favorite from '@mui/icons-material/Favorite';
import SmallIconButton from 'components/atoms/Button/SmallIconButton';
import { FavorSection } from 'components/molecules/List/CommentLists';
import { useAppSelector } from 'app/hooks';
import { selectAuth } from 'features/auth/authSlice';

const ExpandMore = styled((props: any) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(0deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));

const TitleSectionContent = styled(CardContent)(({ theme }) => ({
  padding: 'unset',
  display: 'flex',
  justifyContent: 'space-between',
  '&:last-child': {
    padding: 'unset',
  },
}));

const InsideBottomContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  gap: '10px',
  marginTop: '15px',
}));

const UserSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'start',
  gap: '12px',
}));

const EmptySection = styled(Box)(({ theme }) => ({
  width: '45px',
}));

const DetailSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'start',
  justifyContent: 'start',
  gap: '7px',
}));

const NameSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'start',
  gap: '20px',
}));

const NameText = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  color: '#ffffff',
  fontWeight: '500',
}));

const CommitText = styled(NameText)(({ theme }) => ({
  fontWeight: 'bold',
}));

const AnnouncementText = styled(NameText)(({ theme }) => ({
  fontWeight: 'initial',
  fontSize: '12px',
}));

const SmallText = styled(NameText)(({ theme }) => ({
  fontSize: '12px',
  color: '#c1c1c1',
  fontWeight: 'initial',
}));

const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

interface CardCommentListsProps {
  see?: number;
  isDev?: boolean;
  isChart?: boolean;
  announcement?: string;
  Index: number;
  isBig: string;
  name: string;
  comment: string;
  answer: number;
  favor: string;
  imgSize: string;
  commetAction: (deep: number, start: number, data: string) => void;
}

const CardCommentLists: React.FC<CardCommentListsProps> = ({
  see,
  isDev,
  isChart,
  announcement,
  Index,
  isBig,
  name,
  comment,
  answer,
  favor,
  imgSize,
  commetAction,
}) => {
  // const avatar1 = require('assets/Profile/avatar1.png');
  const user0 = require('assets/Profile/buku_default_avatar.png');
  const authState = useAppSelector(selectAuth);
  const [expanded2, setExpanded2] = React.useState<boolean | undefined>(
    isChart
  );

  var items = [];
  for (let i = 0; i < parseInt(isBig); i++) {
    items.push(<EmptySection></EmptySection>);
  }

  const handleExpand2Click = (): void => {
    setExpanded2(!expanded2);
  };

  return (
    <Card
      sx={{
        width: '100%',
        backgroundColor: 'transparent',
        boxShadow: 'unset',
        padding: '.5rem 0rem',
      }}
    >
      <TitleSectionContent>
        <UserSection>
          {items}
          {imgSize === 'big' ? (
            <img
              src={user0}
              style={{ width: '55px', height: '55px' }}
              alt={'user'}
            />
          ) : (
            <img
              src={user0}
              style={{ width: '35px', height: '35px', paddingTop: '4px' }}
              alt={'user'}
            />
          )}
          <DetailSection>
            <NameSection>
              <NameText>{name}</NameText>{' '}
              {isDev ? (
                <SmallIconButton
                  type={'dev'}
                  isClicked={true}
                  color={'yellow'}
                  text={'developer'}
                />
              ) : (
                <></>
              )}{' '}
            </NameSection>
            {comment ? <CommitText>{comment}</CommitText> : <></>}
            {announcement ? (
              <AnnouncementText>{announcement}</AnnouncementText>
            ) : (
              <></>
            )}
            <ExpandMore
              expand={expanded2}
              onClick={handleExpand2Click}
              aria-expanded={expanded2}
              aria-label="show more"
              sx={{ margin: 'unset', padding: 'unset' }}
            >
              {answer ? <SmallText>{answer}h Answer</SmallText> : <></>}
            </ExpandMore>
            {see ? <SmallText>See answers({see})</SmallText> : <></>}
          </DetailSection>
        </UserSection>
        {favor ? (
          <FavorSection style={{ alignSelf: 'flex-start' }}>
            <Checkbox
              style={{ padding: 'unset', paddingBottom: '6px' }}
              {...label}
              icon={<FavoriteBorderOutlinedIcon style={{ color: '#c1c1c1' }} />}
              checkedIcon={<Favorite style={{ color: '#ddb930' }} />}
            />
            <SmallText>{favor}</SmallText>
          </FavorSection>
        ) : (
          <></>
        )}
      </TitleSectionContent>
      <Collapse in={expanded2} timeout="auto" unmountOnExit>
        <InsideBottomContent>
          <img
            src={authState.avatar ? authState.avatar : user0}
            style={{ width: '41px', height: '41px' }}
            alt={'avatar'}
          />
          <ChartInput
            CommetAc={commetAction}
            index={Index}
            deep={1}
            hide={handleExpand2Click}
          />
        </InsideBottomContent>
      </Collapse>
    </Card>
  );
};

export default CardCommentLists;
